import React, { useState } from "react"
import { Card, CardBody, Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap"
import PropTypes from "prop-types"
import formatCurrency from "constants/formatCurrency"
import {
    getCoreParkReports,
    getLaborReports, getLeasePaymentReports, getResolveReports, getSpotHeroReports,
    getSureParkReports, getMonthlyParkingReports,
    getFeeReports,
    getCostReports,
    getEventsReports,
    getAmanoReports
} from "helpers/fakebackend_helper"
import LaborReportTable from "./LaborReportTable"
import CoreParkReportTable from "./CoreParkReportTable"
import SpotHeroReportTable from "./SpotHeroReportTable"
import ResolveReportTable from "./ResolveReportTable"
import SureParkReportTable from "./SureParkReportTable"
import AmanoReportTable from "./AmanoReportTable"
import LeasePaymentReportTable from "./LeasePaymentReportTable"
import MonthlyParkingReportTable from "./MonthlyParkingReportTable"
import FeesReportTable from "./FeesReportTable"
import CostsReportTable from "./CostsReportTable"
import EventsIncomeReportTable from "./EventsIncomeReportTable"
import EventsExpenseReportTable from "./EventsExpenseReportTable"
import ExportPlatformReport from "pages/Reports/ExportPlatformReport"
import EditLeaseAmountForm from "pages/Reports/EditLeaseAmountForm"

const FeeCards = ({ billables = [], payables = [], billableTitle, payableTitle, sm, md, start_date, end_date, locationIds = [] }) => {
    const user = JSON.parse(localStorage.getItem("authUser"))
    const [loadingCards, setLoadingCards] = useState({})

    const totalBillables = billables.reduce((sum, b) => sum + (b.amount || 0), 0)
    const totalPayables = payables.reduce((sum, p) => sum + (p.amount || 0), 0)

    const [modalOpen, setModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [laborData, setLaborData] = useState()
    const [coreParkData, setCoreParkData] = useState()
    const [spotHeroData, setSpotHeroData] = useState()
    const [resolveData, setResolveData] = useState()
    const [sureParkData, setSureParkData] = useState()
    const [amanoData, setAmanoData] = useState()
    const [leasePaymentsData, setLeasePaymentsData] = useState()
    const [monthlyParkingData, setMonthlyParkingData] = useState()
    const [feeData, setFeeData] = useState()
    const [costData, setCostData] = useState()
    const [eventsData, setEventsData] = useState()

    const toggleModal = () => setModalOpen(!modalOpen)

    const handleCardClick = async (item) => {
        if (loadingCards[item.label]) return // prevent double click
        console.log("item: ", item)

        setLoadingCards((prev) => ({ ...prev, [item.label]: true }))
        try {
            const payload = { location_ids: locationIds, start_date, end_date }
            let res

            switch (item.label) {
                case "Labor": res = await getLaborReports(user.token, payload); setLaborData(res.data); break
                case "CorePark": res = await getCoreParkReports(user.token, payload); setCoreParkData(res.data); break
                case "SpotHero": res = await getSpotHeroReports(user.token, payload); setSpotHeroData(res.data); break
                case "Resolve": res = await getResolveReports(user.token, payload); setResolveData(res.data); break
                case "SurePark": res = await getSureParkReports(user.token, payload); setSureParkData(res.data); break
                case "Amano": res = await getAmanoReports(user.token, payload); setAmanoData(res.data); break
                case "Lease Payments": res = await getLeasePaymentReports(user.token, payload); setLeasePaymentsData(res.data); break
                case "Monthly Parking": res = await getMonthlyParkingReports(user.token, payload); setMonthlyParkingData(res.data); break
                case "Fees": res = await getFeeReports(user.token, payload); setFeeData(res.data); break
                case "Costs": res = await getCostReports(user.token, payload); setCostData(res.data); break
                case "Events Income":
                case "Events Expense": res = await getEventsReports(user.token, payload); setEventsData(res.data); break
            }

            setSelectedItem({ ...item, locationIds })
            setModalOpen(true)
        } catch (err) {
            console.error(err)
        } finally {
            setLoadingCards((prev) => ({ ...prev, [item.label]: false }))
        }
    }

    const renderLocationNames = () => {
        if (!selectedItem?.locationIds || selectedItem.locationIds.length === 0) {
            return "All Locations"
        }
        return (
            <ul>
                {selectedItem.locationIds.map((loc, idx) => (
                    <li key={idx}>{typeof loc === "string" ? loc : loc.label || loc.value}</li>
                ))}
            </ul>
        )
    }

    if ((!billables || billables.length === 0) && (!payables || payables.length === 0)) {
        return null
    }

    return (
        <>
            <Row>
                {/* Billables */}
                {billables && billables.length > 0 && (
                    <Col md={6}>
                        <Card className="accordion-gradient-border text-white" style={{ background: "#3C3C3C" }}>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">{billableTitle || "Billables"}</h5>
                                </div>
                                <Row>
                                    {billables.filter(item => (item.amount || 0) > 0)
                                        .map((item, idx) => (
                                            <Col sm={sm} md={md} className="mb-3" key={idx}>
                                                <Card
                                                    className={`border border-success h-100 cursor-pointer ${loadingCards[item.label] ? "opacity-50" : ""}`}
                                                    onClick={() => !loadingCards[item.label] && handleCardClick(item)}
                                                    style={{ background: "rgb(38, 37, 35)" }}
                                                >
                                                    <CardBody className="text-center">
                                                        {loadingCards[item.label] ? (
                                                            <div className="d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                                                                <div className="spinner-border text-success" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <h5 className="mb-1 text-success">${formatCurrency(item.amount)}</h5>
                                                                <p className="text-white mb-0">{item.label}</p>
                                                            </>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                </Row>
                                <div className="text-center mt-3">
                                    <h4 className="fw-bold text-success">
                                        Total {billableTitle || "Billables"}: ${formatCurrency(totalBillables)}
                                    </h4>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                )}

                {/* Payables */}
                {payables && payables.length > 0 && (
                    <Col md={6}>
                        <Card className="accordion-gradient-border text-white" style={{ background: "#3C3C3C" }}>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">{payableTitle || "Payables"}</h5>
                                </div>
                                <Row>
                                    {payables.filter(item => (item.amount || 0) > 0)
                                        .map((item, idx) => (
                                            <Col sm={sm} md={md} className="mb-3" key={idx}>
                                                <Card
                                                    className={`border border-danger h-100 cursor-pointer ${loadingCards[item.label] ? "opacity-50" : ""}`}
                                                    onClick={() => !loadingCards[item.label] && handleCardClick(item)}
                                                    style={{ background: "rgb(38, 37, 35)" }}
                                                >
                                                    <CardBody className="text-center">
                                                        {loadingCards[item.label] ? (
                                                            <div className="d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                                                                <div className="spinner-border text-danger" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <h5 className="mb-1 text-danger">${formatCurrency(item.amount)}</h5>
                                                                <p className="text-white mb-0">{item.label}</p>
                                                            </>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                </Row>
                                <div className="text-center mt-3">
                                    <h4 className="fw-bold text-danger">
                                        Total {payableTitle || "Payables"}: ${formatCurrency(totalPayables)}
                                    </h4>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                )}
            </Row>

            {/* Modal */}
            <Modal isOpen={modalOpen} toggle={toggleModal} size="xl">
                <ModalHeader toggle={toggleModal}>
                    <Row className="w-100 align-items-center">
                        <Col xs="9" className="text-start">
                            {selectedItem?.label === "Lease Amount / day"
                                ? "Update Lease Amount"
                                : (selectedItem?.label || "Details")
                            }
                        </Col>
                        <Col xs="3" className="text-center">
                            {selectedItem?.label === "CorePark" && coreParkData && (
                                <ExportPlatformReport type="CorePark" locations={coreParkData} />
                            )}
                            {selectedItem?.label === "SpotHero" && spotHeroData && (
                                <ExportPlatformReport type="SpotHero" locations={spotHeroData} />
                            )}
                            {selectedItem?.label === "Resolve" && resolveData && (
                                <ExportPlatformReport type="Resolve" locations={resolveData} />
                            )}
                            {selectedItem?.label === "SurePark" && sureParkData && (
                                <ExportPlatformReport type="SurePark" locations={sureParkData} />
                            )}
                            {selectedItem?.label === "Amano" && amanoData && (
                                <ExportPlatformReport type="Amano" locations={amanoData} />
                            )}
                        </Col>
                    </Row>
                </ModalHeader>
                <ModalBody>
                    {selectedItem?.label === "Labor" && laborData ? (
                        <LaborReportTable locations={laborData} />
                    ) : selectedItem?.label === "CorePark" && coreParkData ? (
                        <CoreParkReportTable locations={coreParkData} />
                    ) : selectedItem?.label === "SpotHero" && spotHeroData ? (
                        <SpotHeroReportTable locations={spotHeroData} />
                    ) : selectedItem?.label === "Resolve" && resolveData ? (
                        <ResolveReportTable locations={resolveData} />
                    ) : selectedItem?.label === "SurePark" && sureParkData ? (
                        <SureParkReportTable locations={sureParkData} />
                    ) : selectedItem?.label === "Amano" && amanoData ? (
                        <AmanoReportTable locations={amanoData} />
                    ) : selectedItem?.label === "Lease Payments" && leasePaymentsData ? (
                        <LeasePaymentReportTable locations={leasePaymentsData} />
                    ) : selectedItem?.label === "Monthly Parking" && monthlyParkingData ? (
                        <MonthlyParkingReportTable locations={monthlyParkingData} />
                    ) : selectedItem?.label === "Fees" && feeData ? (
                        <FeesReportTable locations={feeData} />
                    ) : selectedItem?.label === "Costs" && costData ? (
                        <CostsReportTable locations={costData} />
                    ) : selectedItem?.label === "Events Income" && eventsData ? (
                        <EventsIncomeReportTable locations={eventsData} />
                    ) : selectedItem?.label === "Events Expense" && eventsData ? (
                        <EventsExpenseReportTable locations={eventsData} />
                    ) : selectedItem?.label === "Lease Amount / day" ? (
                        <EditLeaseAmountForm item={selectedItem} />
                    ) : (
                        <>
                            <p><strong>Amount:</strong> ${formatCurrency(selectedItem?.amount || 0)}</p>
                            <div>
                                <strong>Locations:</strong>
                                {renderLocationNames()}
                            </div>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    )
}

FeeCards.propTypes = {
    billables: PropTypes.arrayOf(
        PropTypes.shape({
            amount: PropTypes.number,
            label: PropTypes.string
        })
    ),
    payables: PropTypes.arrayOf(
        PropTypes.shape({
            amount: PropTypes.number,
            label: PropTypes.string
        })
    ),
    sm: PropTypes.number,
    md: PropTypes.number,
    locationIds: PropTypes.array // can be strings or objects with {label, value}
}

export default FeeCards